import Page from 'modules/DnaAbout'

export default Page

